import { fetchAgg } from '../../../../common/utils/fetch-agg';
import { GQL_OPERATION_NAME, getSlackChannelsQuery } from './query';

export type SlackChannel = {
	id: string;
	name: string;
	isPrivate?: boolean | null;
};

export type SlackChannelsPayload = {
	channels: SlackChannel[];
	nextCursor?: string | null;
};

type SlackChannelsResponse = {
	search?: {
		configuration?: {
			thirdPartySlackChannels?: SlackChannelsPayload | null;
		} | null;
	} | null;
};

type SlackChannelsVariables = {
	cloudId: string;
	limit?: number;
};

export interface SlackChannelsProps {
	cloudId: string;
	limit?: number;
	aggAbsoluteUrl?: string;
	headers?: Record<string, string>;
}

/** Fetches the authenticated user's Slack channels for use in the channel filter dropdown. */
export const getSlackChannels = async ({
	cloudId,
	limit,
	aggAbsoluteUrl,
	headers,
}: SlackChannelsProps): Promise<SlackChannelsPayload | null> => {
	try {
		const response = await fetchAgg<SlackChannelsVariables, SlackChannelsResponse>({
			graphQuery: getSlackChannelsQuery(),
			variables: { cloudId, ...(limit !== undefined && { limit }) },
			operationName: GQL_OPERATION_NAME,
			aggAbsoluteUrl,
			headers,
		});

		const payload = response.data?.search?.configuration?.thirdPartySlackChannels ?? null;

		if (response.errors?.length) {
			console.warn(
				`[${GQL_OPERATION_NAME}] GraphQL errors for cloudId "${cloudId}":`,
				response.errors,
			);

			if (!payload) {
				throw new Error(
					`[${GQL_OPERATION_NAME}] GraphQL errors prevented loading Slack channels for cloudId "${cloudId}"`,
				);
			}
		}

		return payload;
	} catch (error) {
		console.error(`[${GQL_OPERATION_NAME}] Failed to fetch Slack channels:`, error);
		throw error;
	}
};
